export default __webpack_public_path__ + "bcd63c1a1683c4338cad81e025ffe137.webp";